export enum TaskCategory {
    CUSTOMER_RELANCE = 'CUSTOMER_RELANCE',
    MISSING_DATA = 'MISSING_DATA',
    OTHER = 'OTHER',
}
